// Copyright (c) StrangeBee 2024

import { SecurityColors } from '@Constants/colors';
import { useLocalMessage } from '@Helpers/locale';
import { QuickFiltersAvailable } from '@Hooks/useQuickFilters';
import StatsCard from '@Molecules/StatsCard/StatsCard';
import { useListAllFields } from '@Queries/describeQueries';
import React, { ReactElement } from 'react';
import { WidgetOutput, ObjectTypeV1 } from 'thehive-sdk';

import './CaseStats.scss';

interface CaseStatsProps {
    quickFilters: QuickFiltersAvailable;
}

const CaseStats = React.memo(({ quickFilters }: CaseStatsProps): ReactElement => {
    const i = useLocalMessage();

    const { data: describeData } = useListAllFields();
    const severityField = describeData?.case.attributes.find(({ name }) => name === 'severity');
    const { status: filterStatus, severity: filterSeverity } = quickFilters;

    const statusWidget: WidgetOutput = {
        id: 'stats-status',
        type: 'donut',
        options: {
            stacked: false,
            field: 'status',
            filters: [],
            entity: ObjectTypeV1.CASE,
            periodDateField: '_createdAt',
        },
    };

    const severityWidget: WidgetOutput = {
        id: 'stats-severity',
        type: 'donut',
        options: {
            stacked: false,
            field: 'severity',
            filters: [],
            entity: ObjectTypeV1.CASE,
            periodDateField: '_createdAt',
            customize: severityField?.labels.map((label, index) => ({
                name: severityField?.values[index],
                color: SecurityColors[label],
                label,
            })),
        },
    };

    return (
        <div className="case-display-stats">
            <StatsCard
                widget={statusWidget}
                onItemClick={(value) => filterStatus(value)}
                title={i('case.stats.status')}
            />

            <StatsCard
                widget={severityWidget}
                onItemClick={(value) => filterSeverity(value as any)}
                title={i('case.stats.severity')}
            />
        </div>
    );
});

export default CaseStats;
